
export const updateNRTime = (action, dispatch) => {
    dispatch({
      type: 'UPDATE_NR_TIME',                
      value: action                
  });     
};